import { render } from "./CollectionCardImage.vue?vue&type=template&id=67485e88"
import script from "./CollectionCardImage.vue?vue&type=script&lang=js"
export * from "./CollectionCardImage.vue?vue&type=script&lang=js"

import "./CollectionCardImage.vue?vue&type=style&index=0&id=67485e88&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__